var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["BancontactCard"] = 'bancontactCard';
    PaymentMethod["BancontactMobile"] = 'bancontactMobile';
    PaymentMethod["CashOnDelivery"] = 'cashOnDelivery';
    PaymentMethod["Creditcard"] = 'creditcard';
    PaymentMethod["Fake"] = 'fake';
    PaymentMethod["Ideal"] = 'ideal';
    PaymentMethod["Klarna"] = 'klarna';
    PaymentMethod["KlarnaAccount"] = 'klarna_account';
    PaymentMethod["MBway"] = 'mbway';
    PaymentMethod["MobilePay"] = 'mobilepay';
    PaymentMethod["Multibanco"] = 'multibanco';
    PaymentMethod["Oney"] = 'oney';
    PaymentMethod["Paypal"] = 'paypal';
    PaymentMethod["SepaDirectDebit"] = 'sepadirectdebit';
    PaymentMethod["Swish"] = 'swish';
    PaymentMethod["ApplePay"] = 'applepay';
    PaymentMethod["GooglePay"] = 'googlepay';
    PaymentMethod["Bizum"] = 'bizum';
    PaymentMethod["Twint"] = 'twint';
    PaymentMethod["Invoice"] = 'invoice';
})(PaymentMethod || (PaymentMethod = {}));
var PaymentServiceProvider;
(function(PaymentServiceProvider) {
    PaymentServiceProvider["Adyen"] = 'adyen';
    PaymentServiceProvider["Fake"] = 'fake';
    PaymentServiceProvider["CashOnDelivery"] = 'cashOnDelivery';
    PaymentServiceProvider["MFGROUP"] = 'mfgroup';
})(PaymentServiceProvider || (PaymentServiceProvider = {}));
var PaymentResult;
(function(PaymentResult) {
    PaymentResult["Success"] = 'success';
    PaymentResult["Approved"] = 'approved';
    PaymentResult["Pending"] = 'pending';
    PaymentResult["Failed"] = 'failed';
    PaymentResult["Redirect"] = 'redirect';
    PaymentResult["Error"] = 'error';
    PaymentResult["Cancelled"] = 'cancelled';
    PaymentResult["Refused"] = 'refused';
    PaymentResult["InternalError"] = 'internal-error';
    PaymentResult["Received"] = 'received';
})(PaymentResult || (PaymentResult = {}));
var Gender;
(function(Gender) {
    Gender["Male"] = 'MALE';
    Gender["Female"] = 'FEMALE';
    Gender["Unknown"] = 'UNKNOWN';
})(Gender || (Gender = {}));
var CartState;
(function(CartState) {
    CartState["Active"] = "Active";
    CartState["Merged"] = "Merged";
    CartState["Ordered"] = "Ordered";
})(CartState || (CartState = {}));
var CallbackResultCode;
(function(CallbackResultCode) {
    CallbackResultCode["Authorised"] = 'authorised';
    CallbackResultCode["Cancelled"] = 'cancelled';
    CallbackResultCode["Refused"] = 'refused';
    CallbackResultCode["Pending"] = 'pending';
    CallbackResultCode["Received"] = 'received';
})(CallbackResultCode || (CallbackResultCode = {}));

export { CallbackResultCode, CartState, PaymentMethod, PaymentResult, PaymentServiceProvider };
//# sourceMappingURL=types.js.map
